import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-diagrams',
    templateUrl: './diagrams.component.html',
    styleUrls: ['./diagrams.component.css'],
    standalone: false
})
export class DiagramsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
